<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo d-none d-lg-flex">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1">MODV - Admin Dashboard</h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <div class="d-none d-lg-block">
            <b-card-title title-tag="h2" class="font-weight-bold mb-1"> Admin Control Panel </b-card-title>
            <b-card-title title-tag="h2" class="font-weight-bold mb-1"> My Own Document Vault! 👋 </b-card-title>
          </div>
          <b-img class="d-block d-lg-none mobile-logo" fluid :src="appMobileLogoImage" alt="Logo" />

          <b-card-text class="mb-2">v:{{ appVersion }} </b-card-text>

          <b-card-text class="mb-2"> Please sign-in to manage your accounts </b-card-text>

          <b-card-text v-if="isSessionTimeOut" class="mb-2 session-expired-label"> You session expired and you have been logged out </b-card-text>
          <b-card-text v-if="isUnauthorisedAccess" class="mb-2 session-expired-label">
            <a href="mailto: support@modv.io">
              You do not have access to the Admin Control panel, please contact support for more details. <b>Contact Us</b>
            </a>
          </b-card-text>
          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <!-- submit buttons -->
              <b-button type="submit" variant="primary" block @click="login"> Sign in </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <a href="https://modv.io">
              <span>Switch to standard login</span>
            </a>
            <!-- <b-link @click="onClick">
              <span>&nbsp;Create an account</span>
            </b-link> -->
          </b-card-text>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
import { $themeConfig } from '@themeConfig'
import { ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { BRow, BCol, BLink, BCardText, BCardTitle, BImg, BForm, BButton } from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationObserver
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/coming-soon.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      appVersion: process.env.VUE_APP_VERSION,
      isSessionTimeOut: false,
      isUnauthorisedAccess: true
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/coming-soon-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    }
  },
  mounted() {
    if (sessionStorage.getItem('sessionTimeOut')) {
      this.isSessionTimeOut = true
    } else {
      this.isSessionTimeOut = false
    }
    if (sessionStorage.getItem('isUnauthorisedAccess')) {
      this.isUnauthorisedAccess = true
    } else {
      this.isUnauthorisedAccess = false
    }
    sessionStorage.clear()
  },
  methods: {
    login() {
      this.$auth.loginWithRedirect()
    },
    signUp() {
      this.$auth.loginWithRedirect({
        screen_hint: 'signup'
      })
    }
  },
  setup() {
    // App Name
    const { appMobileLogoImage } = $themeConfig.app
    return {
      appMobileLogoImage
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-auth.scss';
@import '~@/assets/scss/variables/_variables';

.mobile-logo {
  margin-bottom: 7rem;
}

.session-expired-label {
  color: $purple;
}
</style>
